export enum StudentXslxHeaders {
    ID ="id",
    NAME = "name",
    DOB = "DOB",
    ROLL_NUMBER = "roll_number",
    SECTION_ID = "section_id",
    PHONE_NUMBER = "phone_number",
    EMAIL = "email",
    PASSWORD = "password"
}